// extracted by mini-css-extract-plugin
export default {"statusInfo":"StatusInfo_statusInfo__3qzSj"};